<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title1"><h1 class="title">ACKNOWLEDGMENTS</h1>
<p class="p"><span>Without the help of a few fellow diehard Billerica memorabilia collectors and historians, this work would not have been possible. With gratitude, I recognize the spirit of sharing that these people have brought to the project. In particular, I would like to express my thanks to just a few.</span></p>
<p class="p-indent"><span>A good number of these images are provided courtesy of lifelong Billerica resident Tom Paskiewicz, whose postcard collection is among the finest assembled. I have enjoyed the collector’s pursuit with Tom and appreciate his willingness to share his material.</span></p>
<p class="p-indent"><span>I also would like to thank the following friends: Joe Campbell, who shared anything and everything he had with me, honoring the community spirit of his ancestors; Anna Mason, who helped me build my own personal collection, shared the stories, love, and spirit that was the essence of the village, and is living history herself; and Paula Jarvis—my old friend—who has, for many years, turned up images that could not have been found anywhere else in the world and shared them gladly with me. Finally, I would like to thank Helen Potter, a longtime artist and teacher, who helped me assemble a few of the best of these images. Her tireless dedication to the preservation of Billerica’s history is only surpassed by her love of others.</span></p>
<p class="p-indent"><span>Unless otherwise noted, all images are from the author’s collection.</span></p></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439623909_ack01.vue?c68294aa